import { EnvironmentProviders, makeEnvironmentProviders, Optional, Provider, SkipSelf } from '@angular/core';
import { DOCUMENT, WINDOW } from './globals';

export const providers: Provider[] = [
    {
        provide: WINDOW,
        useFactory: (injectedWindow: Window) => injectedWindow || (typeof window === 'undefined' ? undefined : window),
        deps: [[new Optional(), new SkipSelf(), WINDOW]]
    },
    {
        provide: DOCUMENT,
        useFactory: (injectedDocument: Document) => injectedDocument || (typeof document === 'undefined' ? undefined : document),
        deps: [[new Optional(), new SkipSelf(), DOCUMENT]]
    }
];

export function provideDfDom(): EnvironmentProviders {
    return makeEnvironmentProviders(providers);
}
